import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.string.includes.js";
export default {
  isEnabled: function isEnabled(_ref) {
    var features = _ref.features;
    return function (flag) {
      return features.includes(flag);
    };
  }
};